<template>
    <ds-popover
        class="sms-broadcast-recipient-count"
        position="right"
        position-fixed
    >
        <template #reference>
            <button
                class="recipient-count"
                data-qa="contact-count-popover"
            >
                <span :class="{ invalid, empty }">{{ phoneNumberCountMessage }}</span>
            </button>
        </template>

        <template #default>
            <div class="popover-content">
                <span class="popover-message">If you have a different number of recipients and phone numbers, some of your recipients might not have a phone number in their contact record or may have multiple numbers. Be sure to review your contact record phone number data. </span>
            </div>
        </template>
    </ds-popover>
</template>

<script>
import { getValidRecipientCount } from '@/components/broadcast/utils/smsBroadcast.util';

export default {
    props: {
        invalid: Boolean,
        optStatuses: {
            type: Array,
            default: () => [],
        },
        recipients: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
        };
    },
    computed: {
        empty() {
            return this.totalValidRecipientCount === 0;
        },

        totalValidRecipientCount() {
            const { optStatuses, recipients } = this;

            return getValidRecipientCount({ optStatuses, recipients });
        },

        phoneNumberCountMessage() {
            const totalValidRecipientCount = this.totalValidRecipientCount.toString();

            return ` ${totalValidRecipientCount} ${this.phoneNumberText(this.totalValidRecipientCount)}`;
        },
    },
    methods: {
        phoneNumberText(phoneNumberCount) {
            if (phoneNumberCount === 0 || phoneNumberCount > 1) {
                return 'phone numbers';
            }

            return 'phone number';
        },
    },
};
</script>

<style lang="scss" scoped>
.sms-broadcast-recipient-count {
    --popover-width: #{px-to-rem(320)};
    --popover-min-width: #{px-to-rem(320)};
}

.popover-content {
    padding: $spacing-200;
    font-size: $font-size-md;
}

.popover-message {
    font-size: $font-size-md;
    line-height: $line-height-lg;
}

.recipient-count {
    padding: 0;
    background-color: transparent;
    color: $color-blue;
    font-size: $font-size-xs;
    font-weight: $font-weight-regular;
}

.tooltip-message {
    margin-top: $spacing-100;
}

.empty {
    color: $color-text-subtle;
}

.invalid {
    color: $color-red;
}
</style>
